import { render, staticRenderFns } from "./PresConnect.vue?vue&type=template&id=64eca60a&scoped=true&"
import script from "./PresConnect.vue?vue&type=script&lang=js&"
export * from "./PresConnect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64eca60a",
  null
  
)

export default component.exports